import * as React from "react";
import { useSelector } from "react-redux";

import { ROUTES } from "@config/work.routing";

import { Container } from "@ui/Atoms/Grid";
import { NotFound as NotFoundOrganism } from "@ui/Organisms";

import { Markdown, MarkdownSelfLinkRenderer } from "@containers/Markdown";

import { useTranslate } from "@hooks/useTranslate";

import { isUserLoggedIn as isUserLoggedInSelector } from "@work/redux/user/user.selectors";

interface Props {
  isNested?: boolean;
}

export const NotFound = (props: Props): React.ReactElement => {
  const translate = useTranslate("batwork_pwa_generic");
  const isUserLoggedIn = useSelector(isUserLoggedInSelector);

  const componentProps = {
    htmlMetaTitleText: translate("not_found_title"),
    titleText: translate("not_found_title"),
    bodyText: isUserLoggedIn ? (
      <Markdown renderers={{ link: MarkdownSelfLinkRenderer }}>
        {translate("not_found_body_client_md", {
          link: ROUTES.CLIENT_DASHBOARD,
        })}
      </Markdown>
    ) : (
      translate("not_found_body")
    ),
  };

  return props.isNested ? (
    <NotFoundOrganism {...componentProps} />
  ) : (
    <Container>
      <NotFoundOrganism {...componentProps} />
    </Container>
  );
};
